import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ListViewViewModel from '@/ViewModels/Views/ListViewViewModel';
import Messenger from '@/Utility/Messenger';
import Utilities from '@/Utility/Utilities';
import * as CoreFrameDTOs from "coreframetypings/dto";
import TaskUIListenerHelper from '@/UIListener/TaskUIListenerHelper';
import RADApplication from '@/Management/RADApplication';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';

export default class PDTaskUIListener extends UIListener {
    constructor() {
        super();
    }

    /**
     * @override
     */
    public onBeforeRender(context: DetailViewContext): void {
        TaskUIListenerHelper.onBeforeRender(context);
    }

    /**
     * @override
     */
    public onBeforeRenderSummaryView(context: DetailViewContext): void {
        TaskUIListenerHelper.onBeforeRenderSummaryView(context);
    }

    /**
     * @override
     */
    public onBeforeListViewRender(context: ListViewViewModel, dto: CoreFrameDTOs.IListViewDTO): void {
        this.updateOperations(context, dto);

        if (this.isIncompleteTaskList(context, dto))
            this.updateToIncompleteTaskList(context, dto);
    }

    /**
     * @override
     */
    public onBeforeCallOperation(context: DetailViewContext | ListViewViewModel, operation: string): boolean | JQueryPromise<boolean> | JQueryDeferred<boolean> {
        const helperResult = TaskUIListenerHelper.onBeforeCallOperation(context, operation);
        if (helperResult != null)
            return helperResult;

        if (this.isListViewContext(context)) {
            if (context.dataGrid.selected().length != 1 && (operation == 'AssignToCurrentUser' || operation == 'ReleaseAssignment')) {
                const box = MessageBoxViewModel.createNoticeMessageBox(null, 'ILLEGAL_MULTIPLESELECTION_NOTICE')
                RADApplication.getInstance().showMessageBox(box, false);
                return false;
            }
        }

      	return super.onBeforeCallOperation(context, operation);
    }

    /**
     * @override
     */
    public onAfterCallOperation(context: DetailViewContext | ListViewViewModel, operation: string, args: CoreFrameDTOs.IOperationResultDTO): void {
        if (TaskUIListenerHelper.onAfterCallOperation(context, operation, args))
            return;

        if (this.isListViewContext(context)) {
            Messenger.createMessageAndSend('RefreshUserTasksMessage');
            return;
        }
    }

    private updateOperations(context: ListViewViewModel, dto: CoreFrameDTOs.IListViewDTO): void {
        const type = this.getType(context);
        if (type === TaskType.MyTasks) {
            dto.operations = dto.operations.filter(x => x.name != 'AssignToCurrentUser');
        }
        else if (type === TaskType.UnassignedTasks) {
            dto.operations = dto.operations.filter(x => x.name != 'ReleaseAssignment');
        }
    }

    private updateToIncompleteTaskList(context: ListViewViewModel, dto: CoreFrameDTOs.IListViewDTO): void {
        // Wir ändern den Name hier ab, da andernfalls die Spaltenkonfiguration von der normalen Liste greifen würde und IsCompleted wieder einblenden würde.
        dto.name = 'RAD.RADFoundation.ProblemDomain.PDTask_Incomplete_LV';
        const column = dto.columns.filter(x => x.name === 'IsCompleted')[0];
        if (column)
            column.isVisible = false;
    }

    private isIncompleteTaskList(context: ListViewViewModel, dto: CoreFrameDTOs.IListViewDTO): boolean {
        if (dto.name !== 'RAD.RADFoundation.ProblemDomain.PDTask_LV')
            return false;

        if (!context.filter)
            return false;

        const index = context.filter.indexOf('IsCompleted');
        if (index === -1)
            return false;

        const subString = context.filter
            .substring(index)
            .replace(' ', '')
            .toLowerCase();

        return subString.startsWith('iscompleted=false');
    }

    private getType(context: ListViewViewModel): TaskType {
        if (Utilities.contains(context.filter, 'Assignee.PDO_ID'))
            return TaskType.MyTasks;

        if (Utilities.contains(context.filter, 'Assignee is null'))
            return TaskType.UnassignedTasks;

        return TaskType.AllTasks;
    }
}

enum TaskType {
    MyTasks,
    UnassignedTasks,
    AllTasks
}

ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.PDTaskUIListener', PDTaskUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('PDTaskUIListener', PDTaskUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');